/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import {ReminderItem} from "@shared/scheduler/reminders/reminderItem-imports";
import {ReminderType} from "@shared/scheduler/reminders/ReminderType";


export default class  EmailReminderItem extends ReminderItem {

	subject: string = null
	body: string = null
	toEmail: string = null

	_isPersonalizationShowing: boolean = false
	_isBodyRequired: boolean = true
	_isSubjectRequired: boolean = true

	constructor(subject, body, title, trigger) {
		super(ReminderType.EMAIL, trigger);
		// console.log("EmailReminderItem: constructor: this ", this)
		this.subject = subject || defaultReminderSubject
		this.body = body || defaultReminderBody
		this.template = {
			subject: this.subject,
			body: this.body
		}
		this.title = title || null
	}

	getTemplate(){
		return {
			subject: this.subject,
			body: this.body
		}
	}

	getTemplateData(){
		return {}
	}


}

export const defaultReminderSubject =
	"Reminder: {{session_name}} with {{coach_full_name}} at {{session_time}} on {{session_date}}"

export const defaultReminderBody =
	"Hi {{invitee_first_name}}," +
	"<br/><br/>" +
	"This is a friendly reminder that our session is at {{session_time}} on {{session_date}}." +
	"<br/><br/>" +
	"Location: {{session_location}}" +
	"<br/><br/>" +
	"Regards," +
	"<br/>" +
	"{{coach_first_name}}"



export function emailReminderValidator(emailReminder, callback) {
	let error

	console.log("emailReminderValidator: emailReminder = ", emailReminder)

	let isBodyEmpty = !emailReminder.body || emailReminder.body === "<p></p>"
	let isSubjectSet = emailReminder.subject || !emailReminder._isSubjectRequired
	let isBodySet = !isBodyEmpty || !emailReminder._isBodyRequired

	if (!isSubjectSet && !isBodySet) {
		error = "Please feel in email subject and body."
	} else if (!isSubjectSet) {
		error = "Please feel in email subject."
	} else if (!isBodySet) {
		error = "Please feel in email body."
	}

	callback(error)
}
